<template>
  <div class="deployment-dashboard">
    <iframe
      class="deployment-dashboard__frame"
      title="Deployment Dashboard"
      src="/deployment-dashboard/index.html"
    />
  </div>
</template>

<script>
export default {
  name: 'DeploymentDashboard'
}
</script>

<style scoped>
.deployment-dashboard {
  height: calc(100vh - 4rem);
  min-height: 40rem;
  padding: 0;
}

.deployment-dashboard__frame {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>